import React from "react";
import "./App.css";
import Bounce from "./components/bounce";
import Drag from "./components/drag";
import Spinner from "./components/spinner";
import Float from "./components/float";
import PlayCatch from "./components/play-catch";

function App() {
  return (
    <div className="App">
      <h4>Framer React</h4>
      <div className="framer-react">
        <Float />
        <PlayCatch />
        <Spinner />
        <Drag />
        <Bounce />
      </div>
      <div style={{ height: "50vh" }} />
    </div>
  );
}

export default App;
